export default __webpack_public_path__ + "static/media/GSP3.1f20deff.png";